var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "zkContent",
        { attrs: { leftStyle: "width:30%", rightStyle: "width:70%" } },
        [
          _c(
            "div",
            { attrs: { slot: "left" }, slot: "left" },
            [
              _c("el-tree", {
                staticClass: "dept-tree-cla",
                attrs: {
                  data: _vm.areas,
                  "default-checked-keys": _vm.defaultKey,
                  "default-expand-all": "",
                  "node-key": "id",
                  "highlight-current": true,
                  "expand-on-click-node": true,
                  "check-on-click-node": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c(
                        "div",
                        {
                          class: {
                            "custom-tree-node": true,
                            "leaf-node-cla": node.isLeaf
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectedAreaFn(data)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "node-text-cla" }, [
                            _vm._v(_vm._s(data.name))
                          ]),
                          _vm._v(" "),
                          _c("zk-operate-bar", {
                            attrs: { onlyIcon: true },
                            on: {
                              remove: function($event) {
                                return _vm.remove(data)
                              },
                              add: function($event) {
                                return _vm.add(data)
                              },
                              update: function($event) {
                                return _vm.update(data)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "right" }, slot: "right" },
            [
              _c(
                "div",
                { staticClass: "header-button-bar" },
                [
                  _c("zk-button-group", {
                    attrs: { toolBar: true },
                    on: { add: _vm.addUser, removeUser: _vm.removeUser }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("zk-table", {
                attrs: { columns: _vm.userCols, data: _vm.users },
                on: { "selection-change": _vm.handleUserSelect }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.state.title,
            visible: _vm.state.areaEditShow,
            "before-close": _vm.onCancel,
            width: "40%"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.state, "areaEditShow", $event)
            }
          }
        },
        [
          _c("zk-area-save-or-update", {
            ref: "saveOrUpdate",
            attrs: { form: _vm.selectedArea, isUpdate: _vm.state.isUpdate }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v(_vm._s(_vm.$t("common.cancel")))
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveOrUpdate } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.state.title,
            "append-to-body": true,
            visible: _vm.state.userTransfer,
            width: "55%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.state, "userTransfer", $event)
            }
          }
        },
        [
          _c("zk-user-transfer", {
            ref: "userTransfer",
            attrs: { selectedData: _vm.selectedData }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.state.userTransfer = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64e031e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e031e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/area/src/main.vue
// module id = null
// module chunks = 